module.exports = __webpack_public_path__ + "static/media/dashboard.1cfc2235.svg";